export default {
  DRAFT: 'DRAFT',
  ENDED: 'ENDED',
  RUNNING: 'RUNNING'
}
